var moduleMap = {
	"./SecondaryNav": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_fmcc-web-platform_platform-experience-lib_dist_esm_index_js-node_modules-4760a8"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_emotion_react_emotion_react"), __webpack_require__.e("node_modules_ucl_aem-library_lazy_recursive-src_components_secondary-nav-ui_SecondaryNav_tsx--77d6f9"), __webpack_require__.e("src_components_secondary-nav-ui_SecondaryNav_scss-src_components_secondary-nav-ui_SideDrawer_scss")]).then(() => (() => ((__webpack_require__(/*! ./src/components/secondary-nav-ui/SecondaryNav.tsx */ "./src/components/secondary-nav-ui/SecondaryNav.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});